import {MessageBase} from './message-base';

export class MessageChartPrint extends MessageBase<MessageChartPrint> {
    // tslint:disable-next-line:variable-name
    private _outputType: string;

    constructor(outputType: string) {
        super(MessageChartPrint);

        this._outputType = outputType;
    }

    get outputType(): string {
        return this._outputType;
    }
}
